// Modern Product Card Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize all modern product cards
  const productCards = document.querySelectorAll('.modern-product-card');
  
  productCards.forEach(card => {
    // Add wishlist functionality
    const wishlistBtn = card.querySelector('.modern-product-card__wishlist');
    if (wishlistBtn) {
      wishlistBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(this, card);
      });
    }
    
    // Add cart button functionality
    const cartBtn = card.querySelector('.modern-product-card__button');
    if (cartBtn) {
      cartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        addToCart(this, card);
      });
    }
    
    // Add click to view product
    card.addEventListener('click', function(e) {
      if (!e.target.closest('.modern-product-card__button') && 
          !e.target.closest('.modern-product-card__wishlist')) {
        const productUrl = this.dataset.productUrl;
        if (productUrl) {
          window.location.href = productUrl;
        }
      }
    });
    
    // Load saved wishlist state
    loadWishlistState(card);
  });
});

// Toggle wishlist function
function toggleWishlist(button, card) {
  const productId = card.dataset.productId;
  const isActive = button.classList.contains('active');
  
  if (isActive) {
    // Remove from wishlist
    removeFromWishlist(productId);
    button.classList.remove('active');
    showNotification('Removed from wishlist', 'info');
  } else {
    // Add to wishlist
    addToWishlist(productId, card);
    button.classList.add('active');
    showNotification('Added to wishlist!', 'success');
  }
}

// Add to wishlist function
function addToWishlist(productId, card) {
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  const productData = {
    id: productId,
    title: card.dataset.productTitle,
    price: card.dataset.productPrice,
    image: card.dataset.productImage,
    url: card.dataset.productUrl
  };
  
  if (!wishlist.find(item => item.id === productId)) {
    wishlist.push(productData);
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
  }
}

// Remove from wishlist function
function removeFromWishlist(productId) {
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  const updatedWishlist = wishlist.filter(item => item.id !== productId);
  localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
}

// Load wishlist state
function loadWishlistState(card) {
  const productId = card.dataset.productId;
  const wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
  const isInWishlist = wishlist.find(item => item.id === productId);
  
  const wishlistBtn = card.querySelector('.modern-product-card__wishlist');
  if (wishlistBtn && isInWishlist) {
    wishlistBtn.classList.add('active');
  }
}

// Add to cart function
function addToCart(button, card) {
  const productId = card.dataset.productId;
  const variantId = card.dataset.variantId;
  
  if (!variantId) {
    showNotification('Product variant not available', 'error');
    return;
  }
  
  // Show loading state
  button.classList.add('loading');
  button.disabled = true;
  
  // Add to cart via Shopify API
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      id: variantId,
      quantity: 1
    })
  })
  .then(response => response.json())
  .then(data => {
    if (data.status === 422) {
      throw new Error(data.description);
    }
    
    showNotification('Added to cart!', 'success');
    updateCartCount();
    
    // Add success animation
    button.style.background = '#4CAF50';
    button.style.borderColor = '#4CAF50';
    setTimeout(() => {
      button.style.background = '';
      button.style.borderColor = '';
    }, 1000);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    showNotification('Failed to add to cart', 'error');
  })
  .finally(() => {
    // Remove loading state
    button.classList.remove('loading');
    button.disabled = false;
  });
}

// Update cart count
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count');
      cartCountElements.forEach(element => {
        element.textContent = cart.item_count;
      });
    })
    .catch(error => {
      console.error('Error updating cart count:', error);
    });
}

// Notification function
function showNotification(message, type = 'info') {
  // Create notification element
  const notification = document.createElement('div');
  notification.className = `notification notification--${type}`;
  notification.textContent = message;
  
  // Style the notification
  const colors = {
    success: '#4CAF50',
    error: '#f44336',
    info: '#2196F3',
    warning: '#ff9800'
  };
  
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: 20px;
    background: ${colors[type] || colors.info};
    color: white;
    padding: 12px 20px;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    z-index: 10000;
    opacity: 0;
    transform: translateX(100%);
    transition: all 0.3s ease;
    font-family: system-ui, -apple-system, sans-serif;
    font-size: 14px;
    font-weight: 500;
  `;
  
  document.body.appendChild(notification);
  
  // Animate in
  setTimeout(() => {
    notification.style.opacity = '1';
    notification.style.transform = 'translateX(0)';
  }, 100);
  
  // Remove after 3 seconds
  setTimeout(() => {
    notification.style.opacity = '0';
    notification.style.transform = 'translateX(100%)';
    setTimeout(() => {
      if (document.body.contains(notification)) {
        document.body.removeChild(notification);
      }
    }, 300);
  }, 3000);
}

// Create modern product card HTML
function createModernProductCard(product) {
  return `
    <div class="modern-product-card" 
         data-product-id="${product.id}"
         data-product-title="${product.title}"
         data-product-price="${product.price}"
         data-product-image="${product.image}"
         data-product-url="${product.url}"
         data-variant-id="${product.variant_id}">
      
      ${product.badge ? `<div class="modern-product-card__badge">${product.badge}</div>` : ''}
      
      <button class="modern-product-card__wishlist" aria-label="Add to wishlist">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      </button>
      
      <div class="modern-product-card__image">
        <img src="${product.image}" alt="${product.title}" loading="lazy">
      </div>
      
      <h3 class="modern-product-card__title">${product.title}</h3>
      <p class="modern-product-card__subtitle">${product.description}</p>
      
      <hr class="modern-product-card__divider">
      
      <div class="modern-product-card__footer">
        <div class="modern-product-card__price">
          <span>$</span>${product.price}
        </div>
        <button class="modern-product-card__button" aria-label="Add to cart">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
            <path d="m397.78 316h-205.13a15 15 0 0 1 -14.65-11.67l-34.54-150.48a15 15 0 0 1 14.62-18.36h274.27a15 15 0 0 1 14.65 18.36l-34.6 150.48a15 15 0 0 1 -14.62 11.67zm-193.19-30h181.25l27.67-120.48h-236.6z"/>
            <path d="m222 450a57.48 57.48 0 1 1 57.48-57.48 57.54 57.54 0 0 1 -57.48 57.48zm0-84.95a27.48 27.48 0 1 0 27.48 27.47 27.5 27.5 0 0 0 -27.48-27.47z"/>
            <path d="m368.42 450a57.48 57.48 0 1 1 57.48-57.48 57.54 57.54 0 0 1 -57.48 57.48zm0-84.95a27.48 27.48 0 1 0 27.48 27.47 27.5 27.5 0 0 0 -27.48-27.47z"/>
            <path d="m158.08 165.49a15 15 0 0 1 -14.23-10.26l-25.71-77.23h-47.44a15 15 0 1 1 0-30h58.3a15 15 0 0 1 14.23 10.26l29.13 87.49a15 15 0 0 1 -14.23 19.74z"/>
          </svg>
        </button>
      </div>
    </div>
  `;
}
